/** 把取回的文件交给浏览器保存：用临时链接触发下载，用完就释放；导出列表、下载请款附件共用。 */
export function saveFinanceFile(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  try {
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
